import { DialogOption } from "../../../../../lib/html5-software-library/src/ranj/eng/dialog/engine/model/Dialog";
import NGTDialogPlayer from "../../dialog/NGTDialogPlayer";
import ChatMessage from "./ChatMessage";
import ChatStatus from "./ChatStatus";

export default class ChatConversation {
    /**
     * @constructor
     * @param {string} npcId 
     */
    constructor(npcId) {
        this._npcId = npcId;

        /** @type {Array<ChatMessage>} */
        this._messages = [];
        /** @type {Array<DialogOption>} */
        this._currentOptions = [];
        /** @type {NGTDialogPlayer} */
        this._contentPlayer = null;

        this._status = ChatStatus.OFFLINE;
    }

    get messages() {
        return this._messages;
    }

    get status() {
        return this._status;
    }

    set status(value) {
        this._status = value;
    }

    get currentOptions() {
        return this._currentOptions;
    }

    get contentPlayer() {
        return this._contentPlayer;
    }

    set contentPlayer(value) {
        this._contentPlayer = value;
    }

    get awaitingPlayerResponse() {
        return !!this._currentOptions;
    }

    /**
     * Adds a chat message
     * @param {ChatMessage} message
     */
    addMessage(message) {
        this._messages.push(message);
    }

    /**
     * Adds options that the player can chose from to chat 
     * @param {Array<DialogOption>} options 
     */
    addOptions(options) {
        this._currentOptions = [...this._currentOptions, ...options];
    }

    /**
     * Clears all current options
     */
    clearOptions() {
        this._currentOptions = [];
    }

    /**
     * Get the amount of unread messages in this conversation
     * @returns {number} The amount of unread messages in this conversation
     */
    getUnreadCount() {
        return this.messages.reduce((prev, curr) => {
            if (!curr.isRead) {
                return prev + 1;
            }
            return prev;
        }, 0);
    }
}